const GlobalNotice = {
  init (Cookies) {

    // Handle fake Marquee
    if ( jQuery('.o-urgent-notice--marquee').length ) {

      let tickerTiming = jQuery('.o-urgent-notice--marquee').find('.o-urgent-notice--marquee-content').data( "ticker-timing" );

      jQuery('.o-urgent-notice--marquee').find('.o-urgent-notice--marquee-content').css( "animation-duration", tickerTiming + "s" );

      jQuery('.o-urgent-notice--marquee').hover(
        function() {
          let adjustedTiming = (parseFloat(tickerTiming) * 10);
          jQuery('.o-urgent-notice--marquee').find('.o-urgent-notice--marquee-content').css( "animation-duration", adjustedTiming + "s" );
        }, function() {
          jQuery('.o-urgent-notice--marquee').find('.o-urgent-notice--marquee-content').css( "animation-duration", tickerTiming + "s" );
        }
      );
    }

    // Handle Modal and header block with a cookie
    // https://github.com/js-cookie/js-cookie
    if(Cookies.get('dismissed_urgent_notice') != "true") {

      if ( jQuery('.o-urgent-notice').length ) {
        jQuery('.o-urgent-notice').removeClass('hide');

        jQuery('.dismiss-notice').click(function() {
          jQuery('.o-urgent-notice').addClass('hide');
          // Cookies.set('dismissed_urgent_notice', 'true', { domain: 'graphedia.ie' });
          Cookies.set('dismissed_urgent_notice', 'true');
        });
      }

      if ( jQuery('.o-modal-urgent-notice').length ) {
        jQuery("#urgentNoticeModal").foundation("open");

        jQuery('.dismiss-notice').click(function() {
          jQuery("#urgentNoticeModal").foundation("close");
          // Cookies.set('dismissed_urgent_notice', 'true', { domain: 'graphedia.ie' });
          Cookies.set('dismissed_urgent_notice', 'true');
        });
      }
    }

  }
};

export default GlobalNotice;
